export { default } from "./PieChartConfig";
